import { ReactElement } from "react";
import { Box, Grid, IconButton, SxProps, Theme, Typography } from "@mui/material";
import { Button } from "../../../../reusable-components";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const overlayBackdropSx: SxProps<Theme> = {
  position: "fixed",
  background: "rgba(6,6,6,0.5)",
  top: 0,
  left: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 90,
  height: "100%",
  width: "100%",
};

const clickTrapSx: SxProps<Theme> = {
  position: "absolute",
  width: "100%",
  height: "100%",
};

const confirmWindowSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "var(--background_2)",
  padding: "17px 15px",
  width: 300,
  minHeight: 160,
  position: "absolute",
  top: 250,
  zIndex: 99,
};

const flexEndSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
};

const messageSx: SxProps<Theme> = {
  fontWeight: "bold",
  fontSize: "14px",
  margin: "20px 0",
};

interface ShowResultOfBetProps {
  toggle: (show: boolean) => void;
  onClose?: () => void;
}

function ShowResultOfBet({ toggle, onClose }: ShowResultOfBetProps): ReactElement {
  const { t } = useTranslation();

  const handleClose = (): void => {
    toggle(false);
    if (onClose !== undefined) {
      onClose();
    }
  };

  return (
    <Box sx={overlayBackdropSx}>
      <Box sx={clickTrapSx} onClick={() => {}} />
      <Box sx={confirmWindowSx}>
        <Box sx={flexEndSx}>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon sx={{ cursor: "pointer" }} />
          </IconButton>
        </Box>

        <Grid container direction="column" alignItems="center" sx={{ padding: "5px", width: "100%" }}>
          <Typography sx={messageSx}>{t("your_bet_is_paid")}</Typography>
          <Button width="200px" onClick={handleClose}>
            Ok
          </Button>
        </Grid>
      </Box>
    </Box>
  );
}

export default ShowResultOfBet;
